import type { CommonEditorTab } from "./reducers";
import { mdiExport } from "@mdi/js";
import { useTranslation } from "react-i18next";
import { NavbarTabButton } from "../shell/NavbarTabButton";

export function NavbarExportTabButton() {
  const { t } = useTranslation();

  return (
    <NavbarTabButton
      tooltip={t("NavbarExportTabButton.tooltip")}
      value={"export" satisfies CommonEditorTab}
      iconPath={mdiExport}
    />
  );
}
